import './SignUp.scss';

import React, { useState, useEffect } from 'react'
import Modal from '../../features/keywords/react/Modal/Modal';
import { subscribe as subscribeToEvent, unsubscribe as unsubscribeFromEvent } from '../../shared/events';
import ActivateSubscription from './ActivateSubscription';
import posthogClient from '../../shared/posthogClient';
import getPosthogEventFromUserState from '../../shared/posthogEvents';
import UpsellContactSupport from './UpsellContactSupport';
import getUserStateAndNextPlan from './getUserStateAndNextPlan';
import CreateUserAndSubscribe from './CreateUserAndSubscribe';

export default function SignUp({user, countryCode}) {

  const [Shown, SetShown] = useState(false);
  const [UserState, SetUserState] = useState(null);
  const [PriceId, SetPriceId] = useState(null);

  const onEvent = e => {
    const { userState, priceId } = getUserStateAndNextPlan(user, e.detail);
    const eventName = getPosthogEventFromUserState(userState);
    SetUserState(userState);
    SetPriceId(priceId);
    SetShown(true);
    posthogClient.capture(eventName);
  };

  useEffect(() => {

    subscribeToEvent("clickedUpgrade", onEvent);
    subscribeToEvent("triggerUpsell", onEvent);

    return () => {
      unsubscribeFromEvent("clickedUpgrade", () => SetUser(null));
      unsubscribeFromEvent("triggerUpsell");
    }
  }, []);

  return (
    <Modal show={Shown} dismissable={false} onClose={() => SetShown(false)}>
      { ['curious_about_even_more_ranking_lists'].includes(UserState) && (
        <UpsellContactSupport />
      ) }
      { ['expired_valid_card', 'curious_about_ranking_lists', 'out_of_ranking_lists'].includes(UserState) && (
        <ActivateSubscription
          priceId={PriceId}
          userState={UserState}
          user={user}
        />
      ) }
      { ['fresh', 'expired_invalid_card'].includes(UserState) && (
        <CreateUserAndSubscribe
          user={user}
          countryCode={countryCode}
          priceId={PriceId}
          userState={UserState}
        />
      ) }
    </Modal>
  )

}